import { storageService } from '@/core/services'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.client && window.location.host === 'spinarium.vip') {
    const isVipMember = Boolean(storageService.get('is-vip-member'))
    if (!isVipMember) {
      return setPageLayout('vip-only')
    }
  }
})
